import Vue from "vue";
import Vuex from "vuex";

import auth from "@/core/modules/auth.module";
import common from "@/core/modules/common.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    common,
  },
});
